import { BackNavigationButton } from "$components/button/back-button";
import { linkToAdminControlPanel } from "../../../../admin/links";
import { linkToClinicAdminControlPanel } from "../../../../clinic-admin/links";
import { getOrganisationIdQueryParam } from "../../../links";
import FacilityLocationsPage from "./page";

interface FacilityLocationRoutesProps {
  facilityId: string;
  userRole: string;
}

const FacilityLocationPageWithBreadcrumbs = ({
  facilityId,
  userRole,
}: FacilityLocationRoutesProps) => {
  const organisationId = getOrganisationIdQueryParam();

  return (
    <>
      <div style={{ padding: "8px 16px 0" }}>
        <BackNavigationButton
          to={
            userRole === "clinic"
              ? linkToClinicAdminControlPanel()
              : linkToAdminControlPanel()
          }
          label={{
            id: "facilityLocations.backToControlPanel",
            defaultMessage: "Back to Control Panel",
          }}
        />
      </div>
      <FacilityLocationsPage facilityId={facilityId} />
    </>
  );
};

export default FacilityLocationPageWithBreadcrumbs;
